import React, {useState} from 'react';
import './button.css'; // 引入包含水波纹效果样式的CSS文件

interface RippleButtonPros {
    icon: string;
    url: string;
}

const RippleButton: React.FC<RippleButtonPros> = (props) => {
    const [ripple, setRipple] = useState({x: 0, y: 0, size: 0, visible: false});

    const handleImageClick = (e: React.MouseEvent<HTMLImageElement>) => {
        const rect = e.currentTarget.getBoundingClientRect();
        const size = Math.max(rect.width, rect.height);
        const x = e.clientX - rect.left - size / 2;
        const y = e.clientY - rect.top - size / 2;
        setRipple({x, y, size, visible: true});

        window.location.href = props.url;
        setTimeout(() => {
            setRipple((prevState) => ({...prevState, visible: false}));
        }, 600); // 600ms 是水波纹动画的持续时间
    };

    return (
        <div className="ripple">
            <div className="ripple-image-container">
                <img
                    src={props.icon}
                    alt="Description"
                    onClick={handleImageClick}
                    className="ripple-image"
                />
                {ripple.visible && (
                    <span
                        className="ripple-effect"
                        style={{
                            top: ripple.y + 'px',
                            left: ripple.x + 'px',
                            width: ripple.size + 'px',
                            height: ripple.size + 'px',
                        }}
                    />
                )}
            </div>
        </div>
    );
};

export default RippleButton;

